import React from 'react';
import { Col, Row } from 'reactstrap';
import LabelInput from '@src/components/LabelInput/LabelInput';

export default props => {
  const { state } = props;
  return (
    <React.Fragment>
      <Row>
        <Col>
          <LabelInput
            name={props.nameLabel !== undefined ? props.nameLabel : 'Name'}
            placeholder={props.namePlaceholder}
            type={'text'}
            required={true}
            {...state.name}
            onChange={event => props.updateForm(event, 'name')}
          />
        </Col>
        <Col>
          <LabelInput
            name={'LPC'}
            type={'text'}
            required={false}
            {...state.lpc}
            onChange={event => props.updateForm(event, 'lpc')}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <LabelInput
            name={'Contact Name'}
            type={'text'}
            {...state.contact_name}
            onChange={event => props.updateForm(event, 'contact_name')}
          />
        </Col>
        <Col>
          <LabelInput
            name={'Email (Separate emails with a comma)'}
            type={'text'}
            {...state.email}
            onChange={event => props.updateForm(event, 'email')}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <LabelInput
            name={'Phone'}
            type={'text'}
            {...state.phone}
            onChange={event => props.updateForm(event, 'phone')}
          />
        </Col>
        <Col>
          <LabelInput
            name={'Fax'}
            type={'text'}
            {...state.fax}
            onChange={event => props.updateForm(event, 'fax')}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <LabelInput
            name={'Address Line 1'}
            type={'text'}
            {...state.address_line_1}
            onChange={event => props.updateForm(event, 'address_line_1')}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <LabelInput
            name={'Address Line 2'}
            type={'text'}
            {...state.address_line_2}
            onChange={event => props.updateForm(event, 'address_line_2')}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <LabelInput
            name={'City'}
            type={'text'}
            {...state.city}
            onChange={event => props.updateForm(event, 'city')}
          />
        </Col>
        <Col>
          <LabelInput
            name={'State'}
            type={'text'}
            {...state.state}
            onChange={event => props.updateForm(event, 'state')}
          />
        </Col>
        <Col>
          <LabelInput
            name={'Zip Code'}
            type={'text'}
            {...state.zip_code}
            onChange={event => props.updateForm(event, 'zip_code')}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};
